import Phaser from 'phaser'
import { RED_BALL_ATLAS_FRAMES, RED_BALL_TEXTURE_KEYS } from '.'
import { Foreground } from '../base/foreground'

export class RedBallForeground extends Foreground {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createForeground() {
    const foreground = this.scene.add.image(
      this.scene.cameras.main.centerX,
      this.scene.cameras.main.centerY + 10,
      RED_BALL_TEXTURE_KEYS.ATLAS,
      RED_BALL_ATLAS_FRAMES.FOREGROUND,
    )
    foreground.setOrigin(0.5, 0.5)

    foreground.scale = 1.03

    this.add(foreground)
  }
}
